import { render, staticRenderFns } from "./sfc-header-slim.vue?vue&type=template&id=ba30bd98&scoped=true&lang=pug&"
import script from "./sfc-header-slim.vue?vue&type=script&lang=js&"
export * from "./sfc-header-slim.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header-slim.vue?vue&type=style&index=0&id=ba30bd98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba30bd98",
  null
  
)

export default component.exports